import { ProviderClientProperty } from '../../types/provider.types'

export const PROPERTY_APP_SESSION: ProviderClientProperty = {
  key: 'appSession',
  type: 'object',
  properties: [{ key: 'id' }, { key: 'values' }],
}

export const PROPERTY_FILES_DOWNLOADED: ProviderClientProperty = {
  key: 'files',
  type: 'array',
  properties: [
    { key: 'pathRelative', type: 'string' },
    { key: 'content', type: 'any' },
  ],
}

export const PROPERTY_INDEXER_NODES: ProviderClientProperty = {
  key: 'nodes',
  type: 'array',
  properties: [
    { key: 'id', type: 'string' },
    { key: 'content', type: 'string' },
    { key: 'contentEmbedding', type: 'string' },
    { key: 'tags', type: 'array' },
  ],
}
